import { FontSize, FontWeight } from 'commons';
import { Text } from 'components';
import { ReportPendingIcon } from 'static/icons';

export function ReportEmpty() {
  return (
    <div className="flex flex-col items-center gap-4 w-full">
      <ReportPendingIcon />
      <Text size={FontSize.font12} weight={FontWeight.bold}>
        Quando gerar um relatório, ele ficará disponível aqui para download.
      </Text>
    </div>
  );
}
